import '@lottiefiles/lottie-player'

import axios from 'axios'
import SectionTitle from 'components/SectionTitle'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import useWebSocket from 'react-use-websocket'
import axiosClient from 'services/axios-client'
import { useBookQuery } from 'store/queries'
import { FinalPreviewContainer } from './style'

const FinalPreview = () => {
  const { bookId } = useParams()
  const [previewAddr, setPreviewAddr] = useState('')
  const [previewDate, setPreviewDate] = useState(null)
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false)

  const { data: book } = useBookQuery(bookId)

  const downloadPdf = (fileInfo) => {
    axios
      .get(fileInfo.fileUrl, {
        responseType: 'blob',
      })
      .then((res) => {
        const downloadLink = document.createElement('a')
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
        downloadLink.href = URL.createObjectURL(pdfBlob)
        downloadLink.download = 'document.pdf'
        downloadLink.click()
        URL.revokeObjectURL(downloadLink.href)
        setIsGeneratingPdf(false)
      })
  }

  const { sendJsonMessage, readyState } = useWebSocket(
    process.env.REACT_APP_WEBSOCKET_URL,
    {
      onMessage: (msg) => {
        const parsedMsg = JSON.parse(msg.data)

        switch (parsedMsg.action) {
          case 'socket_connected':
            break
          case 'book_generated':
            downloadPdf(parsedMsg.fileInfo)
            break
          case 'pong':
            break
          case 'start_pdf':
            generatePreview(parsedMsg.socketId)
            break
          default:
            break
        }
      },
    },
  )

  const connectionStatus = {
    0: 'Connecting',
    1: 'Open',
    2: 'Closing',
    3: 'Closed',
    [-1]: 'Uninstantiated',
  }[readyState]

  useEffect(() => {
    if (bookId) {
      axiosClient
        .get(`PDF/book/${bookId}/preview?is_print=true`)
        .then((res) => {
          if (res.ok) {
            setPreviewAddr(res.data.fileUrl)
            setPreviewDate(moment(res.data.LastModified))
          }
        })
    }
  }, [bookId])

  const generatePreview = (socket_id) => {
    axiosClient.post(`PDF/book/${bookId}/generate?is_print=true`, { socket_id })
  }

  // Send a ws message to the server indicating a preview generation should be started.
  const handleClickGeneratePreview = () => {
    if (connectionStatus === 'Open') {
      sendJsonMessage({
        action: 'startPdf',
      })

      setIsGeneratingPdf(true)
    }
  }

  const downloadPreview = () => {
    axios
      .get(previewAddr, {
        responseType: 'text',
      })
      .then((res) => {
        const downloadLink = document.createElement('a')
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
        downloadLink.href = URL.createObjectURL(pdfBlob)
        downloadLink.download = 'document.pdf'
        downloadLink.click()
        URL.revokeObjectURL(downloadLink.href)
      })
  }

  return (
    <FinalPreviewContainer className="section-container">
      {!previewAddr ? (
        <>
          <div className="modal-inner p20">
            <SectionTitle>Book Preview</SectionTitle>
            <p>
              This will generate a final look pdf of your book. This will
              reflect full image quality and the information that will be sent
              to the publisher.
            </p>
            <p>
              This process can take up to 10 minutes based on the number of
              pages and images you have. Do you wish to continue?
            </p>
          </div>
          {isGeneratingPdf ? (
            <lottie-player
              autoplay
              loop
              style={{ width: '300px', height: '300px', margin: '5% auto' }}
              src="https://assets6.lottiefiles.com/packages/lf20_u98PhF.json"
              speed="1"
            ></lottie-player>
          ) : (
            <div className="btns-wrapper actions">
              <Button
                className="btn-blue btn-dash ml-rem"
                onClick={handleClickGeneratePreview}
              >
                Yes, let&apos;s see it!
              </Button>
            </div>
          )}
        </>
      ) : (
        <>
          {isGeneratingPdf ? (
            <>
              <div className="modal-inner p20">
                <h3 className="section-title">Book Preview</h3>
                <lottie-player
                  autoplay
                  loop
                  style={{ width: '300px', height: '300px', margin: '5% auto' }}
                  src="https://assets6.lottiefiles.com/packages/lf20_u98PhF.json"
                  speed="1"
                ></lottie-player>
              </div>
              <div className="modal-footer"></div>
            </>
          ) : (
            <>
              <div className="modal-inner p20">
                <p>
                  Publish quality preview generated on{' '}
                  {previewDate?.format('DD/MM/YY')}.
                </p>
                <Button className="btn-secondary" onClick={downloadPreview}>
                  Download
                </Button>
              </div>

              <div className="modal-footer">
                <div className="btns-wrapper actions">
                  <Button
                    disabled={isGeneratingPdf}
                    className="btn-secondary"
                    onClick={handleClickGeneratePreview}
                  >
                    Generate New
                  </Button>
                  <Button
                    disabled={!previewAddr && !book?.preview_confirmed}
                    className="btn-green"
                    onClick={async () => {
                      await axiosClient.put(`/book/${bookId}`, {
                        preview_confirmed: true,
                      })
                    }}
                  >
                    Approve Preview
                  </Button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </FinalPreviewContainer>
  )
}

export default FinalPreview
